// router
import { useSearchParams } from 'react-router-dom';

// react
import { useContext } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Box, Grid } from '@mui/material';

// icons
import { AccountBalance as IconFinancing } from '@mui/icons-material';

// context
import { ContextLoans, ContextProject } from '../Project.context';

// pages
import { Details } from './Details/Details';

// dialogs
import { DialogAddFinancingSource } from '../../../dialogs/DialogAddFinancingSource/DialogAddFinancingSource';
import { DialogEditFinancingSource } from '../../../dialogs/DialogEditFinancingSource/DialogEditFinancingSource';

// v2 listing header
import { HeaderListingPage } from '../../../ui/HeaderListingPage/HeaderListingPage';

export const Financing = () => {
	// hooks
	const { t } = useTranslation();

	// state
	const [searchParams, setSearchParams] = useSearchParams();

	// context
	const { project } = useContext(ContextProject);
	const { refetchLoans } = useContext(ContextLoans);

	// vars
	const paramDialog = searchParams.get('dialog');

	// handlers
	const handleCloseDialog = () => {
		setSearchParams((params) => {
			params.delete('dialog');
			params.delete('dialogLoan');
			return params;
		});
	};

	return (
		<>
			{(project?.version === '2') && (
				<HeaderListingPage
					icon={IconFinancing}
					title={t('financing')}
					subtitle={t('financing.subtitle')}
					variant="financial"
				/>
			)}
			<Box sx={{ pt: (project?.version === '2') ? 3 : 0 }}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Details />
				</Grid>
			</Grid>
			</Box>
			<DialogAddFinancingSource
				isOpen={paramDialog === 'addFinancingSource'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchLoans();
				}}
			/>
			<DialogEditFinancingSource
				isOpen={paramDialog === 'editFinancingSource'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchLoans();
				}}
			/>
		</>
	);
};
